export default __webpack_public_path__ + "static/media/Web page close remove 1.54bfb863.svg";